"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var ToastActionLink = function ToastActionLink(_ref) {
  var actionLink = _ref.actionLink,
    _ref$actionLink = _ref.actionLink,
    color = _ref$actionLink.color,
    testIdName = _ref$actionLink.testIdName,
    text = _ref$actionLink.text,
    type = _ref$actionLink.type,
    onActionClick = _ref.onActionClick;
  return /*#__PURE__*/_react["default"].createElement(ActionLink, (0, _extends2["default"])({}, actionLink, {
    color: color || 'blue20',
    onClick: function onClick() {
      return onActionClick(actionLink);
    },
    testId: testIdName ? "hb-toast-".concat(testIdName, "-action--link") : undefined,
    type: type || 'emphasis14'
  }), text);
};
var _default = exports["default"] = ToastActionLink; // -------------------------------- Styles -------------------------------- //
var ActionLink = (0, _styledComponents["default"])(_HBText["default"]).withConfig({
  displayName: "ToastActionLink__ActionLink",
  componentId: "sc-71q1tl-0"
})(["text-align:right;"]);
//# sourceMappingURL=ToastActionLink.js.map